export default ['JsonRPCService', function (JsonRPCService) {
    return {
        getAllProducts: function getAllProducts() {
            return JsonRPCService.send('pc', 'gateway/product', 'getAllProducts', []);
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/services/ProductService.js
// module id = 1792
// module chunks = 0